import {CampaignWorkflowSearchParamKey} from 'common/src/modules/campaignWorkflow/campaignWorkflow.types';
import {DTControlMode} from 'common/src/modules/decisionTree/treeTypes';
import {Routes} from 'common/src/modules/routing/routing.config';
import routingService from 'common/src/modules/routing/routing.service';
import {RootState} from 'common/src/redux/store';
import {poll} from '../../shared/copilot/utils/poll';
import {PollResult} from '../../shared/copilot/copilot.types';

/**
 * Navigate to a specific campaign version while preserving workflow steps from the current URL.
 */
async function navigateToCampaignVersion({
  getState,
  campaignId,
  versionNumber,
  steps,
  mode,
}: {
  getState: () => RootState;
  campaignId: number;
  versionNumber?: number | null;
  steps?: string;
  mode?: DTControlMode;
}) {
  function _isCampaignPageMounted(): PollResult {
    const state = getState();
    const {campaign, versionNumber} = state.campaignPage.campaignTree;

    const isCampaignLoaded = campaign?.id === campaignId && !!versionNumber;

    if (isCampaignLoaded) {
      return {passed: true};
    }

    return {passed: false, reason: 'Campaign page is not loaded'};
  }

  // Get current URL params to preserve workflow steps
  const currentUrl = new URL(window.location.href);
  const currentSteps = steps || currentUrl.searchParams.get(CampaignWorkflowSearchParamKey.Steps);
  const currentMode = mode || currentUrl.searchParams.get('mode');
  const queryParams = {
    ...(!!currentMode ? {mode: currentMode} : {}),
    ...(currentSteps && {[CampaignWorkflowSearchParamKey.Steps]: currentSteps}),
  };

  // Navigate to the campaign version
  routingService.goTo({
    url: Routes.CampaignPage,
    pathParams: {
      campaignId,
      versionNumber: versionNumber ? versionNumber.toString() : 'latest',
    },
    queryParams,
  });

  // Wait for the campaign page to be mounted
  await poll({
    checkFn: _isCampaignPageMounted,
  });
}

export default navigateToCampaignVersion;
